import { Slot, Slottable } from '@radix-ui/react-slot';

import { cn } from '../../lib/utils';

export const HeroTitle: React.FC<
  React.HTMLAttributes<HTMLHeadingElement> & {
    asChild?: boolean;
  }
> = function HeroTitleComponent({ children, className, ...props }) {
  const Comp = props.asChild ? Slot : 'h3';

  return (
    <Comp
      className={cn(
        'hero-title flex flex-col space-y-1 text-center font-heading text-5xl font-semibold text-white sm:text-6xl lg:text-6xl',
        className,
      )}
      {...props}
    >
      <Slottable>{children}</Slottable>
    </Comp>
  );
};
